let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6QB1T")).then(() => parcelRequire('dJc8G'));